module.exports = __webpack_public_path__ + "img/file-manager.726367af.svg";